import "./IntelligentAutomation.css";
import { Link } from "react-router-dom";

const AI_RPA_Usecases = () => {
  return (
    <section className="ia-section pt-0">
 
        <h2 className="ia-heading">Our AI & RPA Use Cases</h2>

        <div className="row g-4">
          {/* Strategy */}
          <div className="col-lg-6">
            <Link to="/AI-Accounting-Finance" className="ia-card-link">
              <div className="ia-card">
                <div className="ia-icon text-center">
                  <i className="bi bi-currency-dollar"></i> 
                </div>
                <h3>Accounting & Finance</h3>

                <p>
                  RPA in accounting and finance automates routine processes like
                  invoice handling, payment matching, reconciliations, and
                  financial reporting.
                </p>
                <a href="/AI-Accounting-Finance">Accounting & Finance →</a>
              </div>
            </Link>
          </div>

          {/* Implementation */}
          <div className="col-lg-6">
            <Link to="/AI-Audit-Compliance" className="ia-card-link">
              <div className="ia-card">
                <div className="ia-icon text-center">
                  <i className="bi bi-shield-check"></i>
                </div>
                <h3>Audit & Compliance</h3>

                <p>
                  RPA helps audit and compliance teams automate data collection,
                  validation, report preparation, and compliance checks across
                  multiple systems.
                </p>
                <a href="/AI-Audit-Compliance">Audit & Compliance →</a>
              </div>
            </Link>
          </div>

          {/* Center of Excellence */}
          <div className="col-lg-6">
            <Link to="/AI-Human-Resources" className="ia-card-link">
              <div className="ia-card">
                <div className="ia-icon text-center">
                  <i className="bi bi-people"></i>
                </div>
                <h3>Human Resources</h3>

                <p>
                  RPA helps Human Resources automate repetitive tasks such as
                  employee onboarding, payroll processing, leave management, and
                  attendance tracking.
                </p>
                <a href="/AI-Human-Resources">Human Resources →</a>
              </div>
            </Link>
          </div>

          {/* Support & Maintenance */}
          <div className="col-lg-6">
            <Link to="/AI-Operations" className="ia-card-link">
              <div className="ia-card">
                <div className="ia-icon text-center">
                  <i className="bi bi-gear"></i>
                </div>
                <h3>Operations</h3>

                <p>
                  RPA helps operations teams automate repetitive tasks such as
                  order processing, data updates, workflow tracking, and status
                  reporting.
                </p>
                <a href="/AI-Operations">Operations →</a>
              </div>
            </Link>
          </div>
        </div>

    </section>
  );
};

export default AI_RPA_Usecases;
